export default [
  {
    name: 'Modelos de Cadernos de Serviços',
    path: 'modelos-cadernos-servicos',
    component: () => import('@/views/parametrosComCa/modelosCadernosServicos/Index.vue'),
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { name: 'Dados', path: '/dados' },
        { name: 'Cadernos de Serviços', path: '/parametros-com-ca/cadernos-servicos' },
        { name: 'Modelos de Cadernos de Serviços' }
      ]
    }
  }
];
